module.exports = __webpack_public_path__ + "static/media/VsmaLogo.4ff6af40.png";